/* eslint-disable no-undef */
import React from 'react';
import { advSearchState } from 'Stores/advSearch';
import { Utils } from 'Utils/utils';
import { withRouter } from 'react-router-dom';
import makeApi, { URLS } from 'Utils/apiUtil';
import userDetail from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';

let cancelCompanyNameCall = null;
const DomainSearch = props => {
  const [inputDomain, setDomainInput] = React.useState('');
  const [errorToolTip, showErrorToolTip] = React.useState(false);
  const [showSuggestion, setShowSuggestion] = React.useState(false);
  const [searchBoxFocus, setSearchBoxFocus] = React.useState(false);
  const [suggestionList, setSuggestionList] = React.useState([]);
  const [focusedIndex, setFocusedIndex] = React.useState(-1);
  const [keyDownPressCount, setKeyDownPressCount] = React.useState(0);
  const [keyUpPressCount, setKeyUpPressCount] = React.useState(0);

  const domainSearch = () => {};

  const getSuggestion = val => {
    setFocusedIndex(-1);
    const config = {
      url: URLS.companyNameWithDomain + userDetail.featureFlags.EU_CONTACTS,
      method: 'POST',
      data: {
        q: val || inputDomain,
      },
    };
    if (cancelCompanyNameCall !== null) {
      cancelCompanyNameCall('cancel');
      cancelCompanyNameCall = null;
    }
    const companyNameCancelCallback = value => {
      cancelCompanyNameCall = value;
    };
    makeApi(config, false, companyNameCancelCallback)
      .then(response => {
        // console.log('DomainSearch response ', response);
        if (response.data.length > 0) setShowSuggestion(true);
        else setShowSuggestion(false);
        setSuggestionList(response.data);
      })
      .catch(error => {
        console.log('suggestionList error ', error);
      });
  };

  const advancedSearch = () => {
    Utils.mixpanelTrack(CONSTANTS.MX_DASHBOARD_EVENTS.ADV_SEARCH_CLICKED, {});
    props.history.push('/advanced-search/contact');
  };
  const searchBtnClick = val => {
    setSuggestionList([]);
    if (Utils.validateDomain(val)) {
      const mxDataMap = {
        domain: val,
      };
      Utils.mixpanelTrack(CONSTANTS.MX_COMMON_EVENTS.ABS_PERFORMED, mxDataMap);
      Utils.totangoTrack(CONSTANTS.TOTANGO.EVENTS.SEARCH,CONSTANTS.TOTANGO.MODULES.DASHBOARD);
      props.history.push('/advanced-search/contact');
      advSearchState.domainSearchFilter(val);
    } else {
      showErrorToolTip(true);
      const ele = document.getElementById('dashboardSearchBox');
      if (ele !== undefined) ele.focus();
    }
  };

  React.useEffect(() => {
    if (document.getElementById('dashboardSearchBox') !== undefined)
      document.getElementById('dashboardSearchBox').focus();
  }, []);

  const onInputClick = e => {
    setFocusedIndex(-1);
    setShowSuggestion(true);
    showErrorToolTip(false);
    if (
      document.getElementsByClassName('suggestion-list-wrap-domain')[0] !==
      undefined
    )
      document
        .getElementsByClassName('suggestion-list-wrap-domain')[0]
        .scrollTo(0, 0);
  };

  const keyDownAction = e => {
    console.log('keyDownAction ', e.keyCode);
    let scrollElement = null;
    if (
      document.getElementsByClassName('suggestion-list-wrap-domain')[0] !==
      undefined
    )
      // eslint-disable-next-line prefer-destructuring
      scrollElement = document.getElementsByClassName(
        'suggestion-list-wrap-domain',
      )[0];

    if (scrollElement !== null || e.keyCode === 13)
      switch (e.keyCode) {
        case 40:
          e.preventDefault();
          setKeyUpPressCount(0);
          if (focusedIndex < suggestionList.length - 1) {
            setFocusedIndex(focusedIndex + 1);
            console.log('key 40 scroll', 34 * (focusedIndex - 3));

            if (
              focusedIndex >= 4 &&
              focusedIndex - 3 >= 0 &&
              keyDownPressCount > 2
            )
              scrollElement.scrollTo(0, 34 * (focusedIndex - 3));
            setKeyDownPressCount(keyDownPressCount + 1);
          }
          break;

        case 38:
          e.preventDefault();
          setKeyDownPressCount(0);
          if (focusedIndex <= suggestionList.length - 1 && focusedIndex > 0) {
            setFocusedIndex(focusedIndex - 1);

            if (
              focusedIndex <= suggestionList.length - 5 &&
              keyUpPressCount > 2
            )
              if (focusedIndex >= 4 && focusedIndex - 4 >= 0)
                scrollElement.scrollTo(0, 34 * (focusedIndex - 1));
              else scrollElement.scrollTo(0, 34 * (focusedIndex - 1));
            setKeyUpPressCount(keyUpPressCount + 1);
          }
          if (focusedIndex === 0) setFocusedIndex(focusedIndex - 1);
          break;
        case 13:
          e.preventDefault();
          showErrorToolTip(false);
          if (focusedIndex >= 0) {
            const val = suggestionList[focusedIndex].domain;
            searchBtnClick(val);
          } else {
            searchBtnClick(inputDomain);
          }

          break;
        default:
          break;
      }
  };

  const closeSuggestion = () => {
    setFocusedIndex(-1);
    setShowSuggestion(false);
    setSearchBoxFocus(false);
  };

  const domainInputChange = e => {
    const val = e.currentTarget.value;
    console.log('v ', val);
    setDomainInput(val);
    showErrorToolTip(false);
    if (val !== '') {
      if (
        document.querySelectorAll('.domain-search .suggestion-list-wrap-domain')
          .length
      )
        document
          .querySelectorAll('.domain-search .suggestion-list-wrap-domain')[0]
          .scrollTo(0, 0);
      getSuggestion(val);
    } else {
      setSuggestionList([]);
    }
  };

  const renderListSuggestion = () => {
    return suggestionList.map((item, index) => {
      return (
        <div
          key={`sugKey${index}`}
          className={`suggestion-item${
            focusedIndex === index ? ' focused' : ''
          } `}
          data-name={item.name}
          data-index={index}
          title={`${item.domain} - ${item.name}`}
          onClick={e => searchBtnClick(item.domain)}
        >
          <i className="material-icons">search</i>
          <span>
            {item.domain} - {item.name}
          </span>
        </div>
      );
    });
  };

  const searchFocusEvent = () => {
    console.log('searchFocusEvent');
    setSearchBoxFocus(true);
  };

  return (
    <div className="domain-search">
      <h1>Search across {CONSTANTS.CONTACT_COUNT_IN_MILLIONS} contacts</h1>
      <div className="search-box">
        <div className="search-icon">
          {/* <i className="fa fa-search" aria-hidden="true" /> */}
          <i className="material-icons">search</i>
        </div>
        <input
          type="text"
          placeholder="Company Name"
          onClick={onInputClick}
          onKeyDown={keyDownAction}
          onChange={domainInputChange}
          onFocus={searchFocusEvent}
          autoComplete="new-password"
          id="dashboardSearchBox"
          className={`${
            searchBoxFocus && showSuggestion && suggestionList.length > 0
              ? ' has-suggestion'
              : ''
          }${searchBoxFocus ? ' search-box-focus' : ''}`}
        />
        <div
          className="common-tooltip-error domain-search-error"
          style={{ display: errorToolTip ? 'block' : 'none' }}
        >
          <span className="top-arrow" />
          Enter a valid domain
        </div>
        <div
          className="search-container"
          onClick={e => searchBtnClick(inputDomain)}
        >
          Search
        </div>

        <div
          className={`suggestion-list ${
            searchBoxFocus && suggestionList.length > 0 && showSuggestion
              ? ''
              : 'hide-suggestion'
          } ${suggestionList.length > 0 ? 'box-design-shadow' : ''}`}
        >
          {showSuggestion && suggestionList.length > 0 && (
            <>
              <div className="seperate-line" />
              <div className="suggestion-list-wrap suggestion-list-wrap-domain">
                {renderListSuggestion()}
              </div>
            </>
          )}
        </div>
        {showSuggestion && suggestionList.length > 0 && (
          <div className="suggestion-mask" onClick={closeSuggestion} />
        )}
      </div>
      <div className="divider">
        <span className="right-bar" />
        <span className="txt-OR"> OR </span>
        <span className="left-bar" />
      </div>
      <div className="serch-msg">
        Search for Contacts by Name, Title, Industry, Location, Company Revenue
        and Headcount
      </div>
      <div className="search-btn">
        <button type="submit" onClick={advancedSearch}>
          Advanced Search
        </button>
      </div>
    </div>
  );
};

// export { DomainSearch };
export default withRouter(DomainSearch);
